module.exports = __webpack_public_path__ + "static/img/20260206.984b225.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/20260206.jpg
// module id = +gZ7
// module chunks = 98